const mortgage = (context) => context.mortgage;

const mortgageProgresses = (context) => context.mortgageProgresses;

const sortedMortgageProgresses = (context) => context.mortgageProgresses.sort((a, b) => {
  const aCompare = a.name;
  const bCompare = b.name;

  if (aCompare < bCompare) {
    return -1;
  }
  if (bCompare < aCompare) {
    return 1;
  }

  return 0;
});

const mortgageProgressToBeReceived = (context, getters) => getters.sortedMortgageProgresses
  .filter((item) => item.received === false && item.sent === false && item.completed === false);

const mortgageProgressToSendToAgency = (context, getters) => getters.sortedMortgageProgresses
  .filter((item) => item.received === true && item.sent === false && item.completed === false);

const mortgageProgressToBeApproved = (context, getters) => getters.sortedMortgageProgresses
  .filter((item) => item.received === true && item.sent === true && item.completed === false);

const mortgageProgressApproved = (context, getters) => getters.sortedMortgageProgresses
  .filter((item) => item.received === true && item.sent === true && item.completed === true);

const hasMortgageProgressToBeReceived = (context, getters) => getters
  .mortgageProgressToBeReceived.length > 0;

const hasMortgageProgressToSendToAgency = (context, getters) => getters
  .mortgageProgressToSendToAgency.length > 0;

const hasMortgageProgressToBeApproved = (context, getters) => getters
  .mortgageProgressToBeApproved.length > 0;

const hasMortgageProgressApproved = (context, getters) => getters
  .mortgageProgressApproved.length > 0;

// decline items
const declineSelectionToSendToAgency = (context) => context.declineSelectionToSendToAgency;
const declineSelectionToBeApproved = (context) => context.declineSelectionToBeApproved;
const declineSelectionApproved = (context) => context.declineSelectionApproved;

export default {
  mortgage,
  mortgageProgresses,
  sortedMortgageProgresses,
  mortgageProgressToBeReceived,
  mortgageProgressToSendToAgency,
  mortgageProgressToBeApproved,
  mortgageProgressApproved,
  hasMortgageProgressToBeReceived,
  hasMortgageProgressToSendToAgency,
  hasMortgageProgressToBeApproved,
  hasMortgageProgressApproved,
  declineSelectionToSendToAgency,
  declineSelectionToBeApproved,
  declineSelectionApproved,
};
